import React, { useState } from 'react';
import axios from 'axios';
import Botpoison from '@botpoison/browser';
import MarketingConsent from './MarketingConsent';
import './EmailSignup.css';

const botpoison = new Botpoison({
  publicKey: "pk_dfa2d461-5956-459f-b74f-effe29b93222"
});

// Footer email capture. Submits to the same Formspark form as the Contact page
// with formType "Email signup" so the entries are easy to filter and export.
const EmailSignup = () => {
  const [email, setEmail] = useState('');
  const [consent, setConsent] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [status, setStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!consent) {
      setStatus('consent');
      return;
    }
    setIsSubmitting(true);
    setStatus(null);

    try {
      const { solution } = await botpoison.challenge();
      await axios.post('https://submit-form.com/1gaMAFaxt', {
        formType: 'Email signup',
        email,
        marketingConsent: 'Yes',
        _botpoison: solution,
      });
      setStatus('success');
      setEmail('');
      setConsent(false);
    } catch (error) {
      console.error('Email signup error:', error);
      setStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="email-signup">
      <h3 className="email-signup-title">Join Our Email List</h3>
      <p className="email-signup-subtitle">Be the first to hear about specials, game day deals, and events.</p>

      {status === 'success' ? (
        <p className="email-signup-message email-signup-message--success">
          You're on the list. Thanks for signing up!
        </p>
      ) : (
        <form onSubmit={handleSubmit} className="email-signup-form">
          <div className="email-signup-row">
            <label htmlFor="signupEmail" className="visually-hidden">Email address</label>
            <input
              type="email"
              id="signupEmail"
              name="email"
              value={email}
              onChange={(e) => { setEmail(e.target.value); if (status) setStatus(null); }}
              placeholder="Your email address"
              required
              disabled={isSubmitting}
            />
            <button type="submit" className="email-signup-button" disabled={isSubmitting}>
              {isSubmitting ? 'Signing up...' : 'Sign Up'}
            </button>
          </div>
          <MarketingConsent
            id="signupConsent"
            variant="light"
            checked={consent}
            onChange={(e) => { setConsent(e.target.checked); if (status) setStatus(null); }}
            disabled={isSubmitting}
          />
          {status === 'consent' && (
            <p className="email-signup-message email-signup-message--error">
              Please check the box to confirm you'd like to receive our emails.
            </p>
          )}
          {status === 'error' && (
            <p className="email-signup-message email-signup-message--error">
              Sorry, something went wrong. Please try again.
            </p>
          )}
        </form>
      )}
    </div>
  );
};

export default EmailSignup;
